<div
    app-landing-page-section-container
    class="flex-col-reverse lg:flex-row gap-6 mb-0 md:mb-0 pb-0 lg:pb-0"
>
    <div class="flex flex-col basis-1/2 h-full my-auto">
        <translate class="text-headline-5 content-text"
            >Efficient Wagon Rental and Flexible Fleet Management.</translate
        >
        <translate class="content-text text-lg md:text-xl xl:text-xl mt-8"
            >traigo is the innovative planning and analysis platform for your
            fleet. All digital, all on one platform.</translate
        >
        <app-landing-page-go-to-register
            class="mt-10"
        ></app-landing-page-go-to-register>
    </div>
    <app-lottie
        class="basis-1/2 my-lottie w-full md:w-[440px] xl:w-[520px] 2xl:w-[675px]"
        path="/assets/animations/landing-page/welcome/data.json"
    >
    </app-lottie>
</div>
